import { Fab, useMediaQuery, useTheme } from '@material-ui/core'
import DriveEtaIcon from '@mui/icons-material/DriveEta'
import React, { useState } from 'react'
import { Authority } from '../../../core/auth/Authority'
import Button, {
  ButtonProps,
} from '../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { CheckExternalParkingTicketDialog } from './CheckExternalParkingTicketDialog'

export const CheckExternalParkingTicketButton = (props: ButtonProps) => {
  const { className, variant, size } = props
  const [dialogOpen, setDialogOpen] = useState(false)
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      <CheckExternalParkingTicketDialog
        open={dialogOpen}
        close={() => setDialogOpen(false)}
      />
      {!smallScreen ? (
        <Button
          onClick={() => setDialogOpen(true)}
          label="resources.external-parking.actions.checkParkingTicket"
          useSmallVersionBreakpoint={false}
          disabled={!hasAuthority(Authority.EXTERNAL_PARKING_GET_TICKET_BUTTON)}
          color="primary"
          size={size}
          variant={variant}
        >
          <DriveEtaIcon fontSize="small" />
        </Button>
      ) : (
        <Fab className={className} onClick={() => setDialogOpen(true)}>
          <DriveEtaIcon fontSize="small" />
        </Fab>
      )}
    </>
  )
}
